import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Instant Download', 'No Subscription', 'Lifetime Access', '7-Day Guarantee'];
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-5" data-id="element-104" data-mp="9llb731mq8q5">
      <div className="mx-auto max-w-4xl text-center" data-id="element-105" data-mp="4lyx6rdz8oga">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="font-display text-[2.6rem] font-black leading-[1.02] tracking-tight text-ink sm:text-6xl md:text-[4.5rem]" data-id="element-106" data-mp="4njqkdok21ck">
          Solve a Full Year of English Class in Just{' '}
          <span className="italic text-brand" data-id="element-107" data-mp="nczvreb6qhzb">5 Minutes</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-108" data-mp="3d21rlvg2wgmo">
          Join 2,000+ English teachers who stopped improvising. Walk into every
          class with everything ready to teach, speak, and inspire.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-2 max-w-2xl pb-5 pt-2.5 sm:mt-8" data-id="element-109" data-mp="39a378zszjdms">
          <img src="https://cdn.magicpatterns.com/uploads/knFxNTsYwRtnyE8ryrCnV7/cf2b0fec-b912-4d5f-b976-44102fdaab5e.webp" alt="The ESL READY pack shown across six printed volumes, desktop, tablet and phone" className="w-full" data-id="element-110" data-mp="359szbhlmud5a" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="-mt-2 sm:mt-8" data-id="element-111" data-mp="2hk84a0c7fpfn">
          <CtaButton href="#offer" data-id="element-112" data-mp="s3cmgcr3vnrm" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-113" data-mp="nbl58stuaue5">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-114" data-mp="i9vuleaj4iql" data-mpi={index}>
                <span data-id="element-115" data-mp="deq8aed7t21z">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-116" data-mp="1azkwdtv2cmt9">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}